import React from "react";
import styled from "styled-components"

const Box = styled.div`
    background-color: white;
    opacity: .9;
    border-radius: 4px;
    margin: 5px;
    padding: 5px;
    text-align: center;
    display: table-cell;
    color: #333;

    display: flex;
    align-items: center;
    justify-content: center;

    img {
        display: block;
    }

    > div {
        vertical-align: middle;
    }

    img {
      height: auto;
      max-width: 125px;
      max-height: 40px;      
    }
    &.level1 img {
      max-width: 275px;
      max-height: 165px;
    }
    &.level2 img {
      max-width: 200px;
      max-height: 100px;
    }    
    &.level3 img {
      max-width: 200px;
      max-height: 100px;
    }    
    &.level4 img {
      max-width: 175px;
      max-height: 75px;
    }  
    &.level5 img {
      max-width: 150px;
      max-height: 50px;
    }                               
`

function Sponsor(props) {
  return (
    <Box style={props.style} className={props.type}> 
        {props.children}
    </Box>
  );
}

export default Sponsor;